<div class="container mt-4">
  <div class="page-content-section border p-4 rounded shadow-sm">
    <fieldset>
      <legend>{{ 'Attribute' | translate | locale }}</legend>
    </fieldset>
    <div *ngIf="attributes && attributes.length > 0; else noData">
      <ul>
        <li *ngFor="let attribute of attributes">
          <span class="font-weight-bold">{{ attribute.name }}</span>
        </li>
      </ul>
    </div>
    <ng-template #noData>
      <p>{{'No attributes found for the selected set.' | translate }}</p>
    </ng-template>
  </div>
</div>
